import React, {Component} from 'react';
import { Field, reduxForm } from 'redux-form'
import { Button } from 'reactstrap';
import { renderField, renderSelect, renderRadio, validate, renderTextarea } from '../../../SHARED/helpers/validation.helper';
import { connect } from 'react-redux';
import {withRouter} from "react-router";

class EditUserDetailsForm extends Component {
    
    render(){
        const { handleSubmit, message, getDropdownValues, getMonths} = this.props;
        return (
            <div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="contact-header">
                            <span className="contact-title">Contact</span>
                        </div>
                        <div className="contact-message">
                            <span>{message}</span>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-lg-12">
                                    <Field
                                        id="name"
                                        name="name"
                                        type="text"
                                        placeholder="Nume"
                                        component={renderField}
                                    />
                                </div>
                                <div className="col-lg-12">
                                    <Field
                                        id="email"
                                        name="email"
                                        type="text"
                                        placeholder="Email"
                                        component={renderField}
                                    />
                                </div>
                                <div className="col-lg-12">
                                    <Field
                                        id="subject"
                                        name="subject"
                                        type="text"
                                        placeholder="Subiect"
                                        component={renderField}
                                    />
                                </div>
                                <div className="col-lg-12">
                                    <Field
                                        id="message"
                                        name="message"
                                        type="text"
                                        placeholder="Mesaj"
                                        component={renderTextarea}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-12 text-center">
                                <Button className="btn-cinemap-blue contact-button" type="submit">Trimite</Button>
                            </div>
                        </form>
                    </div>
                </div>

            </div>
        )
    }
}
const mapStateToProps = (state, ownProps) => ({ 
    contactMessage: state.pages.contactMessage
})

const form = reduxForm({
    form: 'contactForm', // a unique identifier for this form,
    validate: validate('contactForm'),
})

export default withRouter(connect(mapStateToProps,{})(form(EditUserDetailsForm)));
    



// WEBPACK FOOTER //
// ./src/FO/components/contact/contactForm.js